import { Component } from '@theme/component';

/**
 * Mobile accordion rows for M+G megamenu drawer.
 * Plus/minus toggle — no separate "back" panel.
 *
 * @extends {Component}
 */
export class MgMegamenuDrawer extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('click', this.#onClick);
    this.#mountPromoLinks();
    this.#mountPromoLinksAfterHydration();
  }

  #mountPromoLinksAfterHydration() {
    const section = this.closest('.shopify-section');
    if (!(section instanceof HTMLElement) || section.dataset.hydrated === 'true') return;

    const observer = new MutationObserver(() => {
      if (section.dataset.hydrated !== 'true') return;
      observer.disconnect();
      this.#mountPromoLinks();
    });

    observer.observe(section, { attributes: true, attributeFilter: ['data-hydrated'] });
  }

  #mountPromoLinks() {
    const sources = document.querySelectorAll('[data-mg-drawer-promos]');

    sources.forEach((source) => {
      const handle = source.getAttribute('data-mg-drawer-promos');
      if (!handle) return;

      const trigger = this.querySelector(`[data-mg-drawer-panel="${CSS.escape(handle)}"]`);
      if (!(trigger instanceof HTMLElement)) return;

      const panelId = trigger.getAttribute('aria-controls');
      const panel = panelId ? document.getElementById(panelId) : null;
      if (!(panel instanceof HTMLElement)) return;

      while (source.firstElementChild) {
        panel.append(source.firstElementChild);
      }

      source.remove();
    });
  }

  /** @param {MouseEvent} event */
  #onClick = (event) => {
    const target = /** @type {HTMLElement} */ (event.target);
    const trigger = target.closest('[data-mg-drawer-panel]');

    if (!(trigger instanceof HTMLButtonElement)) return;
    if (!this.contains(trigger)) return;

    event.preventDefault();

    const panelId = trigger.getAttribute('aria-controls');
    if (!panelId) return;

    const panel = document.getElementById(panelId);
    if (!(panel instanceof HTMLElement)) return;

    const isOpen = trigger.getAttribute('aria-expanded') === 'true';

    if (isOpen) {
      panel.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      return;
    }

    panel.hidden = false;
    trigger.setAttribute('aria-expanded', 'true');
  };
}

if (!customElements.get('mg-megamenu-drawer')) {
  customElements.define('mg-megamenu-drawer', MgMegamenuDrawer);
}
